/**
 * 금액 데이터 받아와 100단위 씩 , 나타나는 형식으로 리턴
 * @param param 
 * @returns String
 */
export function AmountFormat(param){
    return param.toLocaleString();
}